export default "__VITE_ASSET__DAScf7kh__"